<template>
  <div class="dilu-page">
    <el-form :inline="true" :model="searchParams" class="demo-form-inline" size="mini">
      <el-form-item label="网关编号" style="margin-right:20px;">
        <el-input v-model="searchParams.gateway" style="width:150px" clearable/>
      </el-form-item>
      <el-form-item label="使用状态"  style="margin-right:20px;">
        <el-select v-model="searchParams.usedStatus" style="width:120px" clearable>
          <el-option label="未使用" value=10 />
          <el-option label="已使用" value=20 />
        </el-select>
      </el-form-item>
      <el-form-item label="经销商" style="margin-right:20px;">
        <el-cascader
          :options="orgList"
          :props="orgProps"
          v-model="searchParams.orgId"
          style="width:100%"
          clearable
          placeholder="请选择"
        />
      </el-form-item>
      <el-form-item label="入库日期" style="margin-right:20px;">
        <DatePicker :start.sync="searchParams.startAt" :stop.sync="searchParams.stopAt"/>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" @click="getGatewayList" style="width:80px;">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="search-submit" style="margin-bottom:15px;">
       <el-button icon="el-icon-plus" type="primary" @click="btnImport" style="margin-right:20px;">批量导入</el-button>
       <el-button icon="el-icon-check" type="success" @click="btnSet">批量设置</el-button>
    </div>
    <DiluTable 
      :list="tableData" 
      :tableConfig="tableConfig" 
      :total="total" 
      :pageSize="searchParams.pageSize" 
      @currentChange="currentChange" 
      @handleSelectionChange="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column prop="imei" width="150" label="网关编号" align="center"/>
      <el-table-column prop="dateOut" width="140" label="入库日期" align="center"/>
      <el-table-column prop="orgDate" width="140" label="出库日期" align="center"/>
      <el-table-column prop="orgId" width="250" label="出库经销商" align="left">
        <template slot-scope="scope">
          <span @click="detail(scope.row)">{{ orgName(scope.row.orgId) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lastOnline" width="180" label="最近在线" align="center"/>
      <el-table-column prop="imsi" width="150" label="IMSI" align="center"/>
      <el-table-column prop="iccid" width="180" label="ICCID" align="center"/>
      <el-table-column prop="projectName" width="250" label="项目名称" align="left">
        <template slot-scope="scope">
          <span @click="detail(scope.row)">{{ scope.row.projectName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <div class="table-operation">
            <span @click="setOrg(scope.row.imei)" icon="el-icon-set-up" style="color:#3456ff;margin-right:10px;">出库</span>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!--出库经销商设置-->
    <OutOrg :gateway="gateway" :outVisible="outVisible" @handleClose="handleClose"/>

    <!--批量出库经销商-->
    <ImportOrg :importVisible="importVisible" @handleClose="handleClose"/>

  </div>
</template>

<script>
import DiluTable from "@/components/public/dilu-table.vue";
import DatePicker from "@/components/public/date-picker.vue";
import OutOrg from "./module/outOrg.vue";
import ImportOrg from "./module/importOrg.vue"; 
export default {
  data() {
    return {
      selectedData: [],
      canSelectNum: true,
      tenentList: [],
      searchParams: {
        gateway: null, 
        orgId: null,
        usedStatus: null,
        startAt: null, 
        stopAt: null, 
        pageNum: 1,
        pageSize: 15,
      },
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      total: 0,
      orgList: [], 
      orgProps: {
        children: "orgList",
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      outVisible: false,
      importVisible: false,
      gateway: null,
      selected: ""
    };
  },
  computed: {},
  components: {
    DiluTable,
    DatePicker,
    OutOrg,
    ImportOrg
  },
  mounted() {
    this.listOrg();
    setTimeout(()=>{
      this.getGatewayList();
    },1000);
  },
  methods: {
    handleSelectionChange(rows) {
      this.selected="";
      for (var i=0; i<rows.length; i++) {
        if (this.selected.length>0) {
          this.selected=this.selected+","+rows[i].imei;
        } else {
          this.selected=rows[i].imei;
        }
      }
    },
    btnImport() {
      this.importVisible=true;
    },
    btnSet() {
      if (this.selected.length>0) {
        this.setOrg(this.selected);
      }
    },
    setOrg(imei) {
      this.gateway=imei;
      this.outVisible=true;
    },
    handleClose() {
      this.outVisible=false;
      this.importVisible=false;
      this.getGatewayList();
     },
    listOrg() {
      this.request.listOrg().then((res) => {
        if (res.code == 0) {
          this.orgList = [res.data];
        }
      });
    },
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.getGatewayList();
    },
    getGatewayList() {
      this.request.stockGateway(this.searchParams).then((res) => {
        if (res.code==0) {
          this.tableData = res.data;
          this.total = res.dataMaxCount;
        }
      });
    },
    detail(e) {
      this.$router.push({
        path: "/project/proinfo/info",
      });
      this.setCurrentData(e);
    },
    orgName(array) {
      if (array!=null&&this.orgList.length>0) {
        var orgName="";
        var item=this.orgList[0];
        if (item!=null) {
          orgName=item.name;
          for (var i=1; i<array.length; i++) {
            for (var j=0; j<item.orgList.length; j++) {
              if (array[i]==item.orgList[j].id) {
                item=item.orgList[j];
                orgName=orgName+"-"+item.name;
                break;
              }
            }
          }  
        }
        return orgName;
      } else {
        return "未使用";
      }
    },
  },
};
</script>

<style scoped>
</style>